import { z } from 'zod';
/**
 * Customer-facing ticket status.
 *
 * Deliberately coarser than the helpdesk's own workflow states: a customer is
 * told whether their request has landed, is being worked on, or is done —
 * never how support organises itself internally. Anything finer (an agent
 * snoozing a ticket, a pending-close grace period) is our business, not theirs.
 */ export const SupportTicketStatusSchema = z.enum([
    'received',
    'in_progress',
    'resolved',
    // Support folded it into another request, where it carries on.
    'merged'
]);
/**
 * Support ticket summary for list view
 */ export const SupportTicketSummarySchema = z.object({
    id: z.number(),
    number: z.string(),
    title: z.string(),
    status: SupportTicketStatusSchema,
    createdAt: z.string(),
    updatedAt: z.string()
});
/**
 * A ticket in the customer's list: the summary, plus whether support wrote
 * since the customer last opened it.
 */ export const SupportTicketListItemSchema = SupportTicketSummarySchema.extend({
    hasNewReply: z.boolean()
});
/**
 * List Support Tickets Response Schema
 * GET /api/v2/support/tickets
 */ export const ListSupportTicketsResponseSchema = z.object({
    tickets: z.array(SupportTicketListItemSchema)
});

//# sourceMappingURL=list-support-tickets.schema.js.map